import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Typography,
  Grid,
  Box,
  TextField,
  DialogContent,
  MenuItem,
} from "@mui/material";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import apiRequest from "../../functions/api";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { useMessage } from "../../context/message-context";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import openFile from "../shared/functions/download";
import { FullPageSpinner } from "../lib";
import MessageBox from "../shared/components/MessageBox";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
function A1CertificateDetails(props) {
  const { t } = useTranslation();
  let { antragid } = useParams();
  const navigate = useNavigate();
  const { accessToken, client, admin } = props;
  const { showErrorMessage, hideMessage } = useMessage();
  const [antrag, setAntrag] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [vergangenheit, setVergangenheit] = useState("");
  const [oldRequestMessageBoxOpen, setOldRequestMessageBoxOpen] =
    useState(false);
  const [deleteRequestMessageBoxOpen, setDeleteRequestMessageBoxOpen] =
    useState(false);
    const [stornoGrund, setStornoGrund] = useState("");
    const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "LA1MAP",
      start: admin ? "" : "INIT_AN",
      statement: "DETAILANSICH",
      antrag: antragid,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, datenCb, errorCb);
    // eslint-disable-next-line
  }, []);
  const errorCb = () => {
    setIsLoading(false);
    showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
  };
  const openDeleteRequestMessageBox = () => {
    setDeleteRequestMessageBoxOpen(true);
  };
  const openOldRequestMessageBox = () => {
    setOldRequestMessageBoxOpen(true);
  };
  const closeOldRequestMessageBox = () => {
    setOldRequestMessageBoxOpen(false);
  };
  const closeDeleteRequestMessageBox = () => {
    setDeleteRequestMessageBoxOpen(false);
  };
  const deleteRequestDialogResult = () => {
    aktionausfuehren("storno");
    closeDeleteRequestMessageBox();
  };
  const oldRequestMessageBoxResult = (r) => {
    if (r === "YES") {
      admin
        ? navigate("/LA1MAP/new/" + antragid)
        : navigate("/LA1MAP-INIT_AN/new/" + antragid);
    }
    closeOldRequestMessageBox();
  };
  const datenCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.antrag) {
        setAntrag(response.data.antrag);
      }
      if (response.data.vergangenheit) {
        setVergangenheit(response.data.vergangenheit);
      }
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const aktionausfuehren = (aktion) => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "LA1MAP",
      start: admin ? "" : "INIT_AN",
      statement: "AKTIONEN",
      antrag: antragid,
      aktion: aktion,
      grund: stornoGrund,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, aktionCb, errorCb);
  };
  const aktionCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      hideMessage();
      navigate(-1);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const drucken = (aktion) => {
    var datname = "A1-Bescheinigung";
    const payload = {
      mandant: client,
      program: "LA1MAP",
      start: admin ? "" : "INIT_AN",
      statement: "AKTIONEN",
      antrag: antragid,
      aktion: aktion,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        console.log(response);
        var fileName = datname + "_" + antragid + ".pdf";
        var contentFile = response.data;
        const mimeType = response.headers["content-type"] || "application/pdf";
        openFile(fileName, contentFile, mimeType);
        closeModal();
      })
      .catch(function (error) {
        console.log(error);
        closeModal();
        showErrorMessage(
          t(
            "Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."
          )
        );
      });
  };
  const button_aktion = (aktion) => {
    if (aktion === "edit") {
      if (vergangenheit === "1") {
        openOldRequestMessageBox();
      } else {
        admin
          ? navigate("/LA1MAP/new/" + antragid)
          : navigate("/LA1MAP-INIT_AN/new/" + antragid);
      }
      return;
    }
    if (aktion === "drucken") {
      drucken(aktion);
      return;
    }
    if (aktion === "vers_drucken") {
      drucken(aktion);
      return;
    }
    if (aktion === "besch_drucken") {
      drucken(aktion);
      return;
    }
    if (aktion === "storno") {
      openDeleteRequestMessageBox();
    }
  };
  if (isLoading) {
    return <LoadingComponent />;
  }
  const antrag_zeichnen =
    antrag.length > 0 &&
    antrag.map((element) => {
      if (element.art === "titel") {
        return (
          <Grid item xs={12}>
            <Typography align="center" fullWidth color="primary">
              {element.bez}
            </Typography>
          </Grid>
        );
      }
      if (element.art === "wert") {
        return (
          <Fragment>
            <Grid item xs={12} sm={6}>
              <Box pt={2}>
                <Typography align="center" fullWidth>
                  {element.bez}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                disabled
                variant="outlined"
                fullWidth
                value={element.wert}
              />
            </Grid>
          </Fragment>
        );
      }
      if (element.art === "status") {
        return (
          <Fragment>
            <Grid
              item
              xs={12}
              sm={6}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Box pt={2}>
                <Typography align="center" fullWidth>
                  {element.bez}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography
                align="center"
                fullWidth
                style={{ backgroundColor: "rgb(" + element.farbe + ")" }}
              >
                {element.wert}
              </Typography>
            </Grid>
          </Fragment>
        );
      }
      if (element.art === "multi") {
        return (
          <Fragment>
            <Grid item xs={12} sm={6}>
              <Box pt={2}>
                <Typography align="center" fullWidth>
                  {element.bez}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                disabled
                variant="outlined"
                multiline
                rows={3}
                fullWidth
                value={element.wert}
              />
            </Grid>
          </Fragment>
        );
      }
      if (element.art === "button") {
        return (
          <Fragment>
            <Grid item xs={12} sm={6} lg={3}>
              <Button
                align="center"
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => button_aktion(element.action)}
              >
                {element.bez}
              </Button>
            </Grid>
          </Fragment>
        );
      }
      return "";
    });
  return (
    <Page>
      <Layout>
        <Box p={1}>
          <Typography variant="h6">
            {t("Übersicht aller A1-Bescheinigungen")}
          </Typography>
        </Box>
        <Box p={1}>
          <Grid container spacing={1}>
            {antrag_zeichnen}
          </Grid>
        </Box>
        {antrag.length < 1 && (
          <Typography>
            {t("Der A1-Antrag konnte nicht geladen werden")}
          </Typography>
        )}
      </Layout>
      {showModal && <FullPageSpinner />}
      <MessageBox
        title={t("Hinweis")}
        text={t(
          "Dieser Antrag liegt in der Vergangenheit. Wollen Sie ihn trotzdem bearbeiten?"
        )}
        buttons="YESNO"
        onClose={closeOldRequestMessageBox}
        open={oldRequestMessageBoxOpen}
        handleResponse={oldRequestMessageBoxResult}
      />
      <ResponsiveDialog
        title={t("Antrag stornieren")}
        setOpen={setDeleteRequestMessageBoxOpen}
        open={deleteRequestMessageBoxOpen}
        actionButton={
          <Button
            variant="contained"
            color="primary"
            onClick={deleteRequestDialogResult}
          >
            {t("Stornieren")}
          </Button>
        }
      >
        <DialogContent>
          <Typography variant="body1">
            {t("Bitte geben Sie an, warum Sie den Antrag stornieren wollen.")}
          </Typography>
          <TextField
            select
            variant="outlined"
            label={t("Aus welchem Grund wird der Antrag storniert?")}
            value={stornoGrund}
            onChange={(event) => setStornoGrund(event.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            error={stornoGrund === ""}
          >
            <MenuItem value="5">
              {t(
                "Person erfüllt die Entsendevoraussetzungen, so dass der gesendete Antrag nicht erforderlich ist."
              )}
            </MenuItem>
            <MenuItem value="9">
              {t(
                "Sachverhalt ist nicht eingetreten, so dass der gesendete Antrag nicht erforderlich war und vollständig storniert wird."
              )}
            </MenuItem>
          </TextField>
        </DialogContent>
      </ResponsiveDialog>
    </Page>
  );
}
export default A1CertificateDetails;
